// extracted by mini-css-extract-plugin
module.exports = {"footerOpen":"SRPFilters_footerOpen___LIzZ","move-up":"SRPFilters_move-up__vBUW0","footerClose":"SRPFilters_footerClose__QV7oN","move-down":"SRPFilters_move-down__8EjEM"};